import { Stack, Typography } from "@mui/material";
import { AnalyticCard } from "./AnalyticCard";
import { useParams } from "react-router-dom";
import { BubbleChartBtn } from "../../ui/buttons/BubbleChartBtn";
import { useGetCampaignSummaryQuery } from "../../../api";

type Props = {
  title: string;
  tooltip: string;
  children: React.ReactNode;
  isRoleChartBtnDisabled?: boolean;
};

export const AnalyticCardWrapper = ({
  title,
  tooltip,
  children,
  isRoleChartBtnDisabled,
}: Props) => {
  const { campaign_id, account_id } = useParams();

  const { data } = useGetCampaignSummaryQuery({
    campaign_id: campaign_id!,
  });

  return (
    <AnalyticCard
      flexGrow={1}
      tooltip={tooltip}
      header={
        <Stack flexDirection="row" width="100%" justifyContent="space-between">
          <Typography
            variant="button"
            color="#585858"
            sx={{ lineHeight: "20px", padding: "8px 0 12px 0" }}
          >
            {title}
          </Typography>
          {title === "Gap Analysis" && (
            <>
              {(campaign_id || account_id) && (
                <>
                  <BubbleChartBtn
                    id={account_id! || campaign_id!}
                    isAccounts={!account_id}
                    isDisabled={
                      !!isRoleChartBtnDisabled ||
                      data?.total_accounts_analyzed === 0
                    }
                    isNotActiveRole={!!data?.all_key_roles_inactive}
                  />
                </>
              )}
            </>
          )}
        </Stack>
      }
      body={children}
    />
  );
};
